module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-minimize"
  }, [_c('button', {
    staticClass: "btn btn-fill btn-icon",
    on: {
      "click": _vm.minimizeSidebar
    }
  }, [_c('i', {
    class: _vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    class: {
      toggled: _vm.$sidebar.showSidebar
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand"
  }, [_vm._v(_vm._s(_vm.routeName))])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse"
  }, [_c('form', {
    staticClass: "navbar-form navbar-left navbar-search-form",
    attrs: {
      "role": "search"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.i18n.fr('search_placeholder')
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', [_vm._v("Build: "), _c('strong', [_vm._v(_vm._s(_vm.version.version))]), _vm._v(" "), _c('small', [_vm._v("(" + _vm._s(_vm.version.time) + ")")]), _vm._v(" "), (_vm.debug) ? _c('small', {
    staticClass: "label label-danger"
  }, [_vm._v("dev")]) : _vm._e()])]), _vm._v(" "), _c('drop-down', {
    attrs: {
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "javascript:void(0)"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "ti-bell"
  }), _vm._v(" "), (_vm.sumBy(_vm.$store.state.notifications, 'count')) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("\n              " + _vm._s(_vm.sumBy(_vm.$store.state.notifications, 'count')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "notification"
  }, [_c('b', {
    staticClass: "caret"
  })])]), _vm._v(" "), _vm._l((_vm.$store.state.notifications), function(n) {
    return _c('li', [_c('router-link', {
      staticStyle: {
        "padding-right": "50px"
      },
      attrs: {
        "to": n.link
      }
    }, [(n.count) ? _c('span', {
      staticClass: "label label-success",
      staticStyle: {
        "position": "absolute",
        "right": "10px"
      }
    }, [_vm._v(_vm._s(n.count))]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.i18n.fr(n.title)) + "\n            ")])], 1)
  })], 2), _vm._v(" "), _c('drop-down', {
    attrs: {
      "tag": "li",
      "title": "Language",
      "icon": "ti-world"
    }
  }, _vm._l((_vm.i18n.lang), function(x, l) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.changeLocal(l)
        }
      }
    }, [_vm._v(_vm._s(l.toUpperCase()))])])
  }))], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e18ff7ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/TopNavbar.vue
// module id = 535
// module chunks = 55